import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Response} from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor(private httpClient: HttpClient) { }

  checkMaintenance() {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'Maintenance');
  }

  getMaintenanceDateTime() {
    return this.httpClient.get<Response<string[]>>(environment.apiPath + 'Maintenance/DateTime');
  }
}
